// extracted by mini-css-extract-plugin
module.exports = {"root":"ColumnAccessor_root__3n-vo","cell":"ColumnAccessor_cell__2Bkut","firstCellAccent":"ColumnAccessor_firstCellAccent__30gfp"};